/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {Media} from "../model/media";
import {TrainingRoom} from "../model/training-room";

@Injectable({
    providedIn: "root",
})
export class SimDigitalSignageService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public getMediaById(digitalSignageMediaId: string) {
        return super.get<Media>(`/api/DigitalSignage/GetMediaById`, {digitalSignageMediaId: digitalSignageMediaId});
    }

    public getTrainingRoom(trainingRoomId: string) {
        return super.get<TrainingRoom>(`/api/DigitalSignage/GetTrainingRoom`, {trainingRoomId: trainingRoomId});
    }
}